import React from "react"

import ImageGallery from "react-image-gallery"

import galleryImage01 from "../../../images/Indoor_Cameras/IN-8015_HD/IN-8015HD-vs-IN-6012HD.webp"
import galleryImage01Thumb from "../../../images/Indoor_Cameras/IN-8015_HD/IN-8015HD-vs-IN-6012HD.webp"
import galleryImage02 from "../../../images/Indoor_Cameras/IN-8015_HD/IN-8015HD-vs-IN-6012HD.webp"
import galleryImage02Thumb from "../../../images/Indoor_Cameras/IN-8015_HD/IN-8015HD-vs-IN-6012HD_thumb.webp"
import galleryImage03 from "../../../images/Indoor_Cameras/IN-8015_HD/IN-8015HD-vs-IN-6014HD_night.webp"
import galleryImage03Thumb from "../../../images/Indoor_Cameras/IN-8015_HD/IN-8015HD-vs-IN-6014HD_night_thumb.webp"
import galleryImage04 from "../../../images/Indoor_Cameras/IN-8015_HD/IN-8015HD-vs-IN-6014HD_2.webp"
import galleryImage04Thumb from "../../../images/Indoor_Cameras/IN-8015_HD/IN-8015HD-vs-IN-6014HD_2_thumb.webp"

require("react-image-gallery/styles/css/image-gallery.css")

export class IN8015ImageQGallery extends React.Component {
  render() {
    const images = [{ original: galleryImage01, thumbnail: galleryImage01Thumb }, { original: galleryImage02, thumbnail: galleryImage02Thumb }, { original: galleryImage03, thumbnail: galleryImage03Thumb }, { original: galleryImage04, thumbnail: galleryImage04Thumb }];

    return (
      <div style={{ padding: '15px',maxWidth: '1115px', margin: '2.5rem 0 2.5rem 0', boxShadow: '0 2px 3px 0 rgb(0 0 0 / 36%' }}>
        <ImageGallery items={images} lazyLoad={true} showPlayButton={false} />
      </div>
    );
  }
}

export default IN8015ImageQGallery
